import { ROLE_PLURAL_LABELS } from "constants/roleLabels";

const numberFormatter = new Intl.NumberFormat("en-US");

const OUTCOME_LABELS = {
    pending: "بانتظار الإرسال",
    retrying: "ستتم المحاولة مجددًا",
    accepted: "تم قبوله",
    no_device: "بدون جهاز مسجل",
    pruned: "جهاز غير صالح",
    failed: "فشل",
};

const STATUS_LABELS = {
    queued: "في قائمة الانتظار",
    processing: "جارٍ الإرسال",
    complete: "اكتملت",
    failed: "تعذرت",
};

export const formatReachSummary = (reach) =>
    `سيصل إلى ${numberFormatter.format(reach.reachable)} من أصل ${numberFormatter.format(
        reach.users,
    )}`;

export const notificationOutcomeLabel = (outcome) => OUTCOME_LABELS[outcome] || outcome || "—";

/**
 * The Arabic reason for a Firebase failure code.
 *
 * The results table showed the raw code — «messaging/invalid-argument» — to an
 * operator who has no way to read it. An unknown code still shows as itself,
 * because a code we cannot name is more useful than "حدث خطأ".
 */
const FAILURE_LABELS = {
    "messaging/registration-token-not-registered": "الجهاز لم يعد مسجلًا",
    "messaging/invalid-registration-token": "رمز الجهاز غير صالح",
    "messaging/invalid-argument": "رمز الجهاز غير صالح",
    "messaging/mismatched-credential": "الجهاز مسجل لتطبيق آخر",
    "messaging/third-party-auth-error": "تعذر التحقق من الجهاز",
    "messaging/invalid-payload": "محتوى الإشعار غير مقبول",
    "messaging/internal-error": "خطأ مؤقت في فايربيز",
    "messaging/server-unavailable": "خدمة فايربيز غير متاحة",
    "messaging/quota-exceeded": "تجاوزنا الحد المسموح للإرسال",
    token_missing: "حُذف الجهاز قبل الإرسال",
    fcm_send_failed: "تعذر الإرسال إلى الجهاز",
    fcm_batch_failed: "تعذر الاتصال بفايربيز",
};

export const notificationFailureLabel = (failureCode) =>
    failureCode ? FAILURE_LABELS[failureCode] || failureCode : "—";

export const notificationStatusLabel = (status) => STATUS_LABELS[status] || status || "—";

export const notificationTargetLabel = (target, cities, userName = null) => {
    if (target?.userId) {
        // An account id is an identifier, not a quantity. It used to go through
        // numberFormatter, so account 26358 read as "حساب رقم 26,358".
        return userName ? `الحساب: ${userName}` : `حساب رقم #${target.userId}`;
    }

    const city = cities.find((item) => String(item.id) === String(target?.cityId));
    const parts = [ROLE_PLURAL_LABELS[target?.role] || target?.role || "الجمهور"];
    parts.push(city?.name || (target?.cityId ? `مدينة رقم ${target.cityId}` : "كل المدن"));

    if (target?.activity === "ordered_within") {
        parts.push(`طلبوا خلال ${numberFormatter.format(target.activityDays)} يومًا`);
    } else if (target?.activity === "never_ordered") {
        parts.push("لم يطلبوا من قبل");
    } else {
        parts.push("كل الحسابات النشطة");
    }
    return parts.join(" · ");
};

export { numberFormatter };
